const app = angular.module('msi.tracking', []);

app.service('tracking', require('./tracking.service'));

module.exports = app.name;
